export enum ApplianceDetailsTestHooks {
  ApplianceDetailsForm = 'appliance-details-form',
  ApplianceCodeSelect = 'appliance-details-appliance-code__select',
  ApplianceCategorySelect = 'appliance-details-appliance-category__select',
}
